export const creditorRecalledReasons = [
  "bankruptcy",
  "deceased",
  "paid_prior",
  "fraud",
  "settlement_agreement_prior_to_sale",
  "low_performance",
  "no_longer_represented",
  "other",
  "dispute_representation_prior_to_sale", "unapproved_keeper_request",
] as const;

export type CreditorRecalledReason = (typeof creditorRecalledReasons)[number];

export const creditorRecalledReasonLabels: Record<CreditorRecalledReason, string> = {
  bankruptcy: "Bankruptcy",
  deceased: "Deceased",
  paid_prior: "Paid Prior",
  fraud: "Fraud",
  settlement_agreement_prior_to_sale: "Settlement Agreement Prior To Sale",
  low_performance: "Low Performance",
  no_longer_represented: "No Longer Represented",
  other: "Other",
  dispute_representation_prior_to_sale: "Dispute/Representation prior to sale",
  unapproved_keeper_request: "Unapproved Keeper Request",
};

export const creditorRecalledReasonOptions = [
  {value: "bankruptcy", label: "Bankruptcy"},
  {value: "deceased", label: "Deceased"},
  {value: "paid_prior", label: "Paid Prior"},
  {value: "fraud", label: "Fraud"},
  {value: "settlement_agreement_prior_to_sale", label: "Settlement Agreement Prior To Sale"},
  {value: "low_performance", label: "Low Performance"},
  {value: "no_longer_represented", label: "No Longer Represented"},
  {value: "other", label: "Other"},
  {value: "dispute_representation_prior_to_sale", label: "Dispute/Representation prior to sale"},
  {value: "unapproved_keeper_request", label: "Unapproved Keeper Request"},
];

export const recallStatuses = [
  "completed",
  "declined_by_partner",
  "declined_by_bounce",
  "pending",
  "requested",
  "excluded_from_sale",
  "excluded_from_capital_call_pending",
  "excluded_from_capital_call_completed",
] as const;

export type RecallStatus = (typeof recallStatuses)[number];

export const recallStatusLabels: Record<RecallStatus, string> = {
  completed: "Completed",
  declined_by_partner: "Declined by Partner",
  declined_by_bounce: "Declined by Bounce",
  pending: "Pending",
  requested: "Requested",
  excluded_from_sale: "Excluded from Sale",
  excluded_from_capital_call_pending: "Excluded from Capital Call Pending",
  excluded_from_capital_call_completed: "Excluded from Capital Call Completed",
};

export const accountResolutions = ["close_account", "revert_to_pre_recall_status"] as const;

export type AccountResolution = (typeof accountResolutions)[number];

export const accountResolutionLabels: Record<AccountResolution, string> = {
  close_account: "Close Account",
  revert_to_pre_recall_status: "Revert to Pre-Recall Status",
};

export const DECLINED_STATUSES: RecallStatus[] = ["declined_by_partner", "declined_by_bounce"];
